export enum TextTransform {
  Uppercase = 'uppercase',
}
